import type { ReactNode } from "react"
import React from "react"
import {
    HorizontalStack,
    HeadingMedium,
    Text,
} from "@mallardbay/lib-react-components"

import Avatar from "~components/shared/todo-lib-react-components/avatar"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly avatar?: string
    readonly title: string
    readonly subtitle: string
    readonly icon?: ReactNode
    readonly name?: string
    readonly testId?: string
}

export default function AvatarAndInfo({
    avatar,
    title,
    subtitle,
    icon,
    name,
    testId,
}: Props) {
    const styles = useStyles()

    return (
        <Box style={styles.root} testId={testId}>
            <Box style={styles.avatar}>
                <Avatar src={avatar} name={name} />
            </Box>
            <HeadingMedium>{title}</HeadingMedium>

            <HorizontalStack>
                {icon}
                <Text>{subtitle}</Text>
            </HorizontalStack>
        </Box>
    )
}

function useStyles() {
    return {
        root: {
            display: "grid",
            gridTemplateColumns: "auto 1fr",
            gridTemplateRows: "auto auto",
        },
        avatar: {
            gridRow: "1 / -1",
            display: "flex",
            alignItems: "center",
            marginRight: "10px",
        },
    }
}
